export default __webpack_public_path__ + "static/media/icon-liquidacion.c0f2301e.svg";